import type { FC, ReactNode } from 'react';
import Icon from '@components/Icon';

interface BlockInstructionsProps {
  helperText?: string;
  subHelperText?: string | ReactNode;
}

export const BlockInstructions: FC<BlockInstructionsProps> = ({ helperText = '', subHelperText }) => {
  return (
    <div
      data-testid="block-instruction-text"
      className="border-info-100 bg-info-50 text-info-500 flex gap-x-5 border-b p-5 align-baseline"
    >
      <Icon className="h-3.5 w-3.5 shrink-0 pt-0.5" name="book" />
      <div className="text-xs leading-[18px]! font-medium">
        {helperText}
        {!!subHelperText && (
          <>
            {helperText && <br />}
            {subHelperText}
          </>
        )}
      </div>
    </div>
  );
};
